import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { pyramidCardMotion } from './motion';
import { pyramidChromeTone } from './palette';

export const pyramidTheme: FlowThemeDefinition = {
  id: 'pyramid',
  label: 'Pyramid',
  description: 'A path ribbon draws itself across a 3D grid to a bigger pyramid at every step.',
  category: 'classic',
  chromeTone: pyramidChromeTone,
  swatch: 'linear-gradient(135deg, #737B99 0%, #9C8FB2 50%, #E6D9CC 100%)',
  cardGlass: 'default',
  cardMotion: pyramidCardMotion,
  burstSize: 280,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createPyramidScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
